import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../ui/dialog';
import { Button } from './primitives';

/*
 * Gate for transitions that can't be taken back.
 *
 * On the old screen a status change fired the PATCH the instant the dropdown
 * changed — no confirmation, no undo. One mis-click on "Cancelled" cancelled a
 * paid order immediately.
 *
 * Reversible changes don't come through here; they commit optimistically and
 * offer Undo in a toast. This is only for the ones a toast can't rescue.
 */
const ConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel = 'Confirm',
  onConfirm,
  isPending = false,
}) => (
  <Dialog
    open={open}
    onOpenChange={(next) => {
      if (!isPending) onOpenChange(next);
    }}
  >
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2 text-base font-semibold text-nysmah-dark">
          <span
            className="flex items-center justify-center w-7 h-7 rounded-lg bg-[#FCF2F2] text-[#C2453D] shrink-0"
            aria-hidden="true"
          >
            <AlertTriangle className="w-4 h-4" />
          </span>
          {title}
        </DialogTitle>
        <DialogDescription className="text-[12.5px] text-nysmah-muted">
          {description}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="gap-2">
        <Button
          variant="ghost"
          onClick={() => onOpenChange(false)}
          disabled={isPending}
        >
          Keep as is
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isPending}>
          {isPending ? 'Working…' : confirmLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default ConfirmDialog;
